// extracted by mini-css-extract-plugin
export default {"container":"NVBasicModal_container__vV0f6","title":"NVBasicModal_title__NOu-Z","svg":"NVBasicModal_svg__9HlLQ"};